import State from 'interfaces/state/State';

export const isError$ = (state: State): boolean => state.stats.isError;
export const isLoading$ = (state: State): boolean => state.stats.isLoading;
export const active_jobs$ = (state: State): number => state.stats.active_jobs;
export const active_jobs_all$ = (state: State): number => state.stats.active_jobs_all;
export const statisticTracks$ = (state: State) => state.stats.tracks;
